import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { DexUser } from '@/models/user/dex-user.model';
import User from '@/models/user/user.model';
import { redirectToUnauthorized } from '@/utils/services/accounts';

// eslint-disable-next-line unicorn/no-useless-undefined
export const dexUserAtom = atomWithStorage<DexUser | undefined>('dexUser', undefined);

export const authorizedDexAtom = atom<boolean>((get): boolean => {
  const dexUser = get(dexUserAtom);
  return !!dexUser && User.authorizeDex(dexUser, () => {redirectToUnauthorized();});
});
